import React, { useEffect } from 'react';
import './TravelHero.scss';

const TravelHero = () => {
    useEffect(() => {
        // Preload hero image for better performance
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = '/assets/images/banners/travel.jpg';
        link.fetchPriority = 'high';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    const heroStyle = {
        backgroundImage: 'url(/assets/images/banners/travel.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    };

    return (
        <section className="travel-hero-section">
            <div className="travel-hero-container">
                <div className="travel-hero-inner" style={heroStyle}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="travel-hero-content">
                                    <h1 className="travel-hero-title">
                                        Explore World with Marsh
                                    </h1>
                                    <p className="travel-hero-description">
                                        Discover amazing destinations, create unforgettable memories, and explore the world with our expertly crafted tour packages. From breathtaking landscapes to vibrant cultures, we bring you the best tour experiences tailored to your dreams.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TravelHero;

